function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function(...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var html = document.querySelector('html');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      closeMenuDrawer;
      this.mainDetailsToggle.classList.add('menu-opening');
    }, 100);
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    var html = document.querySelector('html');

    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }, 230);

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    setTimeout(() => {
      html.classList.add('overflow-y-hidden');
    });
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', event => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', event => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', event => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.removeAttribute('aria-hidden');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow && this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach(button => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.checkAvailableOptions();
    this.updateGiftCardDesign();
  }

  updateGiftCardDesign() {
    const variant = this.currentVariant;
    if (!variant || variant.sku !== 'EGIFTCARD') return;

    const newDesign = variant.option1;

    document.querySelectorAll('input[name="properties[Design]"]').forEach(input => {
      input.value = newDesign;
    });
  }

  onVariantChange(event) {
    try {
      this.loadingSpinnerOn();
      this.checkAvailableOptions();
      this.updateOptions();
      this.updateMasterId();

      if (event) {
        this.updateSelectedSwatchValue(event);
      }

      this.toggleAddButton(true, '', false);
      this.updateGiftCardDesign();
      this.updatePickupAvailability();
      this.updateStickybarButtonId();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        if (this.currentVariant.available) {
          this.toggleAddButton(false);
        } else {
          this.toggleAddButton(true, window.variantStrings.soldOut);
        }

        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
        if(window.shopAll.locallyEnabledPDP){
          lcly_reload_0({ upc: this.currentVariant.barcode });
        }
      }

      this.loadingSpinnerOff();
    } catch (error) {
      console.error('Error in onVariantChange:', error);
      this.loadingSpinnerOff();
    }
  }

  loadingSpinnerOn() {
    const mainProduct = document.querySelector('.product-main');
    if (mainProduct) {
      const submitButton = mainProduct.querySelector('.product-form__submit');
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        const loadingSpinner = submitButton.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }
      }
    }
  }

  loadingSpinnerOff() {
    const mainProduct = document.querySelector('.product-main');
    if (mainProduct) {
      const submitButton = mainProduct.querySelector('.product-form__submit');
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        const loadingSpinner = submitButton.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.add('hidden');
        }
      }
    }
  }

  updateBackPreOrders() {
    const variantIdBackPre = this.currentVariant.id;
    const mainProduct = document.querySelector('.product-main');
    const mainVariant = mainProduct.querySelector('#atc-button');
    const buttonText = mainVariant.querySelector('.btn-text');
    const backOrderDateEl = mainProduct.querySelector('.backorder-preorder-date');
    const backOrderDateText = backOrderDateEl.querySelector('.backorder-preorder-date-js');
    const backOrderDateSpan = backOrderDateEl.querySelector('.backorder-preorder-date-span');
    const backPreModalButton = mainProduct.querySelector('.backorder-preorder-modal-button');
    const backOrderModalButton = mainProduct.querySelector('.backorder-modal-button');
    const preOrderModalButton = mainProduct.querySelector('.preorder-modal-button');
    const jsonElBackPre = document.getElementById('variant-backpreorder-data');
    const clydeEl = document.getElementById('attach-clyde-1');
    const isDigitalProduct = clydeEl ? clydeEl.dataset.digitalProduct : undefined;
    const isProductDigital = mainVariant ? mainVariant.getAttribute('data-digital-product') : undefined;

    if (!jsonElBackPre) {
      return;
    }

    if(isProductDigital == 'studio_pro' || isDigitalProduct == 'studio_pro'){
      return;
    }

    let variantDataBackPre;
    try {
      variantDataBackPre = JSON.parse(jsonElBackPre.textContent);
    } catch (e) {
      console.error('Error parsing JSON:', e);
      return;
    }

    const metafieldsBackPre = variantDataBackPre[variantIdBackPre];
    const backOrder = metafieldsBackPre?.backorder;
    const preOrder = metafieldsBackPre?.preorder;
    const madeToOrder = metafieldsBackPre?.made_to_order;
    const isMadeToOrder = madeToOrder === true || madeToOrder == 'true';
    const backOrderDate = metafieldsBackPre?.backorder_date;
    const backOrderDateDate = metafieldsBackPre?.backorder_available_date;
    const preOrderDate = metafieldsBackPre?.preorder_date;
    const preOrderDateDate = metafieldsBackPre?.preorder_available_date;
    const backorderProperties = metafieldsBackPre?.backorder_properties;
    const preorderProperties = metafieldsBackPre?.preorder_properties;
    const backorderLabel = metafieldsBackPre?.backorder_label;
    const preorderLabel = metafieldsBackPre?.preorder_label;

    const removeBackPreOrderInputs = () => {
      if (!mainProduct) return;
      mainProduct.querySelectorAll("input[data-backpreorder='true']").forEach(input => input.remove());
    };

    if (this.currentVariant.available && mainVariant && backOrder == 'true') {
      const backOrderText = mainVariant.getAttribute('data-backorder-text');
      if (buttonText) {
        buttonText.textContent = backOrderText;
      }

      if (clydeEl) {
        clydeEl.classList.add('hidden');
      }

      if (backOrderDate && backOrderDateEl) {
        if (backOrderDateText) {
          backOrderDateText.textContent = backOrderDate;
        }

        if (backOrderDateSpan) {
          backOrderDateSpan.textContent = '';
        }

        backOrderDateEl.classList.remove('hidden');

        if (backOrderModalButton) {
          backOrderModalButton.classList.remove('hidden');
          backOrderModalButton.setAttribute('data-modal-id', 'backordermodal');
        }

        if (preOrderModalButton) {
          preOrderModalButton.classList.add('hidden');
          preOrderModalButton.setAttribute('data-modal-id', 'preordermodal');
        }
      }

      removeBackPreOrderInputs();
      const appendRoot = mainProduct.querySelector('#input-append') || mainProduct;

      const hiddenInputX = document.createElement('input');
      hiddenInputX.type = 'hidden';
      hiddenInputX.name = 'properties[_backOrder]';
      hiddenInputX.value = backOrder;
      hiddenInputX.setAttribute('data-backpreorder', 'true');
      appendRoot.appendChild(hiddenInputX);

      const hiddenInputY = document.createElement('input');
      hiddenInputY.type = 'hidden';
      hiddenInputY.name = 'properties[_backOrderDate]';
      hiddenInputY.value = backOrderDateDate;
      hiddenInputY.setAttribute('data-backpreorder', 'true');
      appendRoot.appendChild(hiddenInputY);

      if (backorderLabel) {
        const hiddenInputLabel = document.createElement('input');
        hiddenInputLabel.type = 'hidden';
        hiddenInputLabel.name = 'properties[_backOrderLabel]';
        hiddenInputLabel.value = backorderLabel;
        hiddenInputLabel.setAttribute('data-backpreorder', 'true');
        appendRoot.appendChild(hiddenInputLabel);
      }

      if (backorderProperties) {
        const visibleInput = document.createElement('input');
        visibleInput.type = 'hidden';
        visibleInput.name = backorderProperties;
        visibleInput.value = backOrderDateDate;
        visibleInput.setAttribute('data-backpreorder', 'true');
        appendRoot.appendChild(visibleInput);
      }
    } else if (this.currentVariant.available && mainVariant && (preOrder == 'true' || isMadeToOrder)) {
      const preOrderText = isMadeToOrder
        ? mainVariant.getAttribute('data-made-to-order-text')
        : mainVariant.getAttribute('data-preorder-text');
      const preorderLineValue = preOrderDateDate || preOrderDate || '';

      if (buttonText) {
        buttonText.textContent = preOrderText;
      }

      if (clydeEl) {
        clydeEl.classList.add('hidden');
      }

      if (preOrderDate && backOrderDateEl) {
        if (backOrderDateText) {
          backOrderDateText.textContent = preOrderDate;
        }

        if (backOrderDateSpan) {
          backOrderDateSpan.textContent = '';
        }

        backOrderDateEl.classList.remove('hidden');

        if (backOrderModalButton) {
          backOrderModalButton.classList.remove('hidden');
          backOrderModalButton.setAttribute('data-modal-id', 'backordermodal');
        }

	        if (preOrderModalButton) {
	          preOrderModalButton.classList.remove('hidden');
	          preOrderModalButton.setAttribute('data-modal-id', isMadeToOrder ? 'madetoordermodal' : 'preordermodal');
	        }
	      }

      removeBackPreOrderInputs();
      const appendRoot = mainProduct.querySelector('#input-append') || mainProduct;

      const hiddenInputX = document.createElement('input');
      hiddenInputX.type = 'hidden';
      hiddenInputX.name = 'properties[_preOrder]';
      hiddenInputX.value = 'true';
      hiddenInputX.setAttribute('data-backpreorder', 'true');
      appendRoot.appendChild(hiddenInputX);

      const hiddenInputY = document.createElement('input');
      hiddenInputY.type = 'hidden';
      hiddenInputY.name = 'properties[_preOrderDate]';
      hiddenInputY.value = preorderLineValue;
      hiddenInputY.setAttribute('data-backpreorder', 'true');
      appendRoot.appendChild(hiddenInputY);

      if (preorderLabel) {
        const hiddenInputLabel = document.createElement('input');
        hiddenInputLabel.type = 'hidden';
        hiddenInputLabel.name = 'properties[_preOrderLabel]';
        hiddenInputLabel.value = preorderLabel;
        hiddenInputLabel.setAttribute('data-backpreorder', 'true');
        appendRoot.appendChild(hiddenInputLabel);
      }

      if (preorderProperties) {
        const visibleInput = document.createElement('input');
        visibleInput.type = 'hidden';
        visibleInput.name = preorderProperties;
        visibleInput.value = preorderLineValue;
        visibleInput.setAttribute('data-backpreorder', 'true');
        appendRoot.appendChild(visibleInput);
      }
    } else if (this.currentVariant.available && mainVariant) {
      const addToCartText = mainVariant.getAttribute('data-atc-text');
      if (buttonText) {
        buttonText.textContent = addToCartText;
      }

      if (clydeEl && (!isDigitalProduct || isDigitalProduct.length < 3)) {
        clydeEl.classList.remove('hidden');
      }

      if (backOrderDateText) {
        backOrderDateText.textContent = '';
      }

      if (backOrderDateSpan) {
        backOrderDateSpan.textContent = '';
      }

      if (backOrderDateEl) {
        backOrderDateEl.classList.add('hidden');
      }
      if (backOrderModalButton) {
        backOrderModalButton.classList.add('hidden');
      }

      if (preOrderModalButton) {
        preOrderModalButton.classList.add('hidden');
      }
      removeBackPreOrderInputs();
    } else {
      if (backOrderDateEl) {
        backOrderDateEl.classList.add('hidden');
      }
      if (backOrderModalButton) {
        backOrderModalButton.classList.add('hidden');
      }
      if (preOrderModalButton) {
        preOrderModalButton.classList.add('hidden');
      }
      removeBackPreOrderInputs();
    }
  }

  checkAvailableOptions() {
    let pickerType = this.querySelectorAll('fieldset').length > 0 ? 'radios' : 'selects';
    let fieldsets =
      pickerType == 'radios'
        ? Array.from(this.querySelectorAll('fieldset'))
        : Array.from(this.querySelectorAll('.product-form__input--dropdown'));
    let productJson = this.getVariantData();
    let selectedOptions = [];
    const mainProductWithBidirectionalClass = document.querySelector('.product-main.bidirectional');
    const bidirectionalFilteringEnabled = (mainProductWithBidirectionalClass) ? true : false;

    // Gather a list of valid combinations of options and check to see if the input passed matches a valid chain of options.
    function validCombo(inputValue, optionLevel) {
      for (let i = 0; i < productJson.length; i++) {
        if (optionLevel == 1) {
          if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) {
            if (productJson[i].available) {
              return true;
            } else {
              return 'unavailable';
            }
          }
        } else {
          if (
            productJson[i].option1 == selectedOptions[0] &&
            productJson[i].option2 == selectedOptions[1] &&
            productJson[i].option3 == inputValue
          ) {
            if (productJson[i].available) {
              return true;
            } else {
              return 'unavailable';
            }
          }
        }
      }
    }

    selectedOptions = fieldsets.map(fieldset => {
      return pickerType == 'radios'
        ? Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value
        : Array.from(fieldset.querySelectorAll('select'), select => select.value);
    });

    // Loop through the option sets starting from the 2nd set and disable any invalid options
    for (let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
      const inputs =
        pickerType == 'radios'
          ? fieldsets[optionLevel].querySelectorAll('input')
          : fieldsets[optionLevel].querySelectorAll('option');

      inputs.forEach(input => {
        let validCombo_check = validCombo(input.value, optionLevel);
         
        if (!bidirectionalFilteringEnabled) {
          input.disabled = validCombo_check ? false : true;
        }

        if (pickerType == 'radios') {
          // Get the label for the current input (this is what the user clicks, the "pill")
          const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
          const legendSpan = fieldsets[optionLevel].querySelector('legend span[data-selected-swatch-value]');

          // Update the selected variant name inside the legend span
          if (input.checked && legendSpan) {
            legendSpan.textContent = input.value;
          }

          if (validCombo_check == 'unavailable') {
            input.classList.add('visually-disabled');
          } else {
            input.classList.remove('visually-disabled');
          }

          if (!bidirectionalFilteringEnabled) {
            label.style.display = input.disabled ? 'none' : ''; // Hide the option
            label.style.opacity = input.disabled ? 0 : 1;
          }
          // label.style.borderStyle = (input.disabled) ? "dashed" : "solid";
          // label.style.textDecoration = (input.disabled) ? "none" : "";
        } else {
          input.hidden = validCombo(input.value, optionLevel) ? false : true;
        }
      });
    }

    // If the default selected option is disabled, select the first available option instead
    for (
      let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false;
      optionLevel < fieldsetsLength && !change;
      optionLevel++
    ) {
      if (pickerType == 'radios') {
        if (fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
          change = fieldsets[optionLevel].querySelector('input:not(:disabled)').checked = true;
        }
      } else {
        if (fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
          change = fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = 'selected';
        }
      }
      // If a new option has been selected, restart the whole process
      if (change) this.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), element => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find(radio => radio.checked)?.value;
      }
    });
  }
  updateVariantMetafield(variantId) {
    const productSelectrnone = document.querySelectorAll('.sku-cta-redirect a');
    productSelectrnone.forEach(elem => {
      elem.style.display = 'none';
    });

    if (!this.currentVariant || !this.currentVariant.id) {
      console.error('currentVariant is not defined.');
      return;
    }

    const productSelectorMain = document.querySelectorAll(
      '.product__info-container .sku-cta-redirect [variantidmeta="' + this.currentVariant.id + '"]'
    );

    productSelectorMain.forEach(elem => {
      const hrefValueMain = elem.getAttribute('href');
      if (hrefValueMain && hrefValueMain !== '') {
        elem.style.display = 'block';
      }
    });

    const productSelectorSticky = document.querySelectorAll(
      '.sticky-bar-pdp .sku-cta-redirect [variantidmeta="' + this.currentVariant.id + '"]'
    );

    productSelectorSticky.forEach(elem => {
      const hrefValueSticky = elem.getAttribute('href');
      if (hrefValueSticky && hrefValueSticky !== '') {
        elem.style.display = 'block';
      }
    });

    if (variantId) {
      const jsonEl = document.getElementById('variant-metafields-data');
      if (!jsonEl) {
        return;
      }

      let variantData;
      try {
        variantData = JSON.parse(jsonEl.textContent);
      } catch (e) {
        console.error('Error parsing JSON:', e);
        return;
      }

      const metafields = variantData[variantId];
      const dealerLocator = document.getElementById('dealer-locator-react-pdp');

      if (!dealerLocator) {
        return;
      }

      if (metafields && metafields.web_exclusive === 'true') {
        dealerLocator.style.display = 'none';
      } else {
        dealerLocator.style.display = '';
      }
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateStickybarButtonId() {
    let variantElementsCTA = document.querySelectorAll('.product-variant-id');
    if (variantElementsCTA != '') {
      variantElementsCTA.forEach(element => {
        element.value = this.currentVariant.id;
      });
    }
  }
  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      variant => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach(element => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map(item => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const destinationTitle = document.getElementById(`Product_title-${this.dataset.section}`);
        const sourceTitle = html.getElementById(
          `Product_title-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationTitleMobile = document.getElementById(`Mobile_Product_title-${this.dataset.section}`);
        const sourceTitleMobile = html.getElementById(
          `MobileProduct_title-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationTextBadge = document.getElementById(`Product_text_badge-${this.dataset.section}`);
        const sourceTextBadge = html.getElementById(
          `Product_text_badge-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationTextBadgeMobile = document.getElementById(`Mobile_Product_text_badge-${this.dataset.section}`);
        const sourceTextBadgeMobile = html.getElementById(
          `Mobile_Product_text_badge-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        const destinationCalloutMessage = document.getElementById(`Product_callout_message-${this.dataset.section}`);
        const sourceCalloutMessage = html.getElementById(
          `Product_callout_message-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        const destinationCalloutMessageMobile = document.getElementById(
          `Mobile_Product_callout_message-${this.dataset.section}`
        );
        const sourceCalloutMessageMobile = html.getElementById(
          `Mobile_Product_callout_message-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        const destinationProductBadges = document.getElementById(`Product_Custom_Badges-${this.dataset.section}`);
        const sourceProductBadges = html.getElementById(
          `Product_Custom_Badges-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationProductBadgesMobile = document.getElementById(
          `Mobile_Product_Custom_Badges-${this.dataset.section}`
        );
        const sourceProductBadgesMobile = html.getElementById(
          `Mobile_Product_Custom_Badges-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        // const destinationProductSaleBadge = document.getElementById(`Product_Sale_badge-${this.dataset.section}`);
        // const sourceProductSaleBadge = html.getElementById(
        //   `Product_Sale_badge-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );

        const destinationProductModelNumber = document.getElementById(`Product_Model_Number-${this.dataset.section}`);
        const sourceProductModelNumber = html.getElementById(
          `Product_Model_Number-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationMobileModelNumber = document.getElementById(`Mobile_Product_Model_Number-${this.dataset.section}`);
        const sourceMobileModelNumber = html.getElementById(
          `Mobile_Product_Model_Number-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationDesktopModelNumber = document.getElementById(`Desktop_Product_Model_Number-${this.dataset.section}`);
        const sourceDesktopModelNumber = html.getElementById(
          `Desktop_Product_Model_Number-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationDescription = document.getElementById(`Description-${this.dataset.section}`);
        const sourceDescription = html.getElementById(
          `Description-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationStickyCTA = document.getElementById(`jackson-fender-sticky-buy-buttons`);
        const sourceStickyCTA = html.getElementById(
          `Product_CTA-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationMediaGallery = document.getElementById(`VariantMedia-${this.dataset.section}`);
        const sourceMediaGallery = html.getElementById(
          `VariantMedia-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationVariantImage = document.querySelector('.jackson-variant-featured-image');
        const sourceVariantImage = html.getElementById(`Variant_featured_image-${this.dataset.section}`);

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const destinationMobile = document.getElementById(`Mobile_price-${this.dataset.section}`);
        const sourceMobile = html.getElementById(
          `Mobile_price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const allSpecs = document.querySelectorAll('.product-specs');
        let specFound = false;
        allSpecs.forEach(specs => {
          const specParent = document.getElementById('Specs');
          const StickyCTASection = document.getElementById('StickyCTA-Specs');
          if (specs.id == `Specs-${requestedVariantId}`) {
            specParent.classList.remove('d-none');
            StickyCTASection.classList.remove('d-none');
            specs.classList.remove('d-none');
            specFound = true;
          } else {
            if (!specFound) {
              specParent.classList.add('d-none');
              StickyCTASection.classList.add('d-none');
            }
            specs.classList.add('d-none');
          }
        });

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const destinationCtaVariantTitle = document.querySelector(
          '.sub-nav__product-info.product-cta .sub-nav__product-info__title'
        );
        const sourceCtaVariantTitle = html.querySelector('.product__title h1');

        const destinationStickyPrice = document.querySelector('.sub-nav__product-info.product-cta .price');
        const sourceStickyPrice = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (sourceMobile && destinationMobile) destinationMobile.innerHTML = sourceMobile.innerHTML;

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        if (destinationTitle && sourceTitle) {
          destinationTitle.innerHTML = sourceTitle.innerHTML;
        }
        if (destinationTitleMobile && sourceTitleMobile) {
          destinationTitleMobile.innerHTML = sourceTitleMobile.innerHTML;
        }
        if (destinationTextBadge && sourceTextBadge) {
          destinationTextBadge.innerHTML = sourceTextBadge.innerHTML;
        }
        if (destinationTextBadgeMobile && sourceTextBadgeMobile) {
          destinationTextBadgeMobile.innerHTML = sourceTextBadgeMobile.innerHTML;
        }
        if (destinationCalloutMessage && sourceCalloutMessage) {
          destinationCalloutMessage.innerHTML = sourceCalloutMessage.innerHTML;
        }
        if (destinationCalloutMessageMobile && sourceCalloutMessageMobile) {
          destinationCalloutMessageMobile.innerHTML = sourceCalloutMessageMobile.innerHTML;
        }
        if (destinationProductBadges && sourceProductBadges) {
          destinationProductBadges.innerHTML = sourceProductBadges.innerHTML;
        }
        if (destinationProductBadgesMobile && sourceProductBadgesMobile) {
          destinationProductBadgesMobile.innerHTML = sourceProductBadgesMobile.innerHTML;
        }
        if (destinationProductModelNumber && sourceProductModelNumber) {
          destinationProductModelNumber.innerHTML = sourceProductModelNumber.innerHTML;
        }
        if (destinationMobileModelNumber && sourceMobileModelNumber) {
          destinationMobileModelNumber.innerHTML = sourceMobileModelNumber.innerHTML;
        }
        if (destinationDesktopModelNumber && sourceDesktopModelNumber) {
          destinationDesktopModelNumber.innerHTML = sourceDesktopModelNumber.innerHTML;
        }
        // if (destinationProductSaleBadge && sourceProductSaleBadge) {
        //   destinationProductSaleBadge.innerHTML = sourceProductSaleBadge.innerHTML;
        // }
        if (destinationDescription && sourceDescription) {
          destinationDescription.innerHTML = sourceDescription.innerHTML;
        }

        if (destinationStickyCTA && sourceStickyCTA) {
          let lclyButton = sourceStickyCTA.querySelector('#lcly-button-0');
          if (lclyButton) {
            lclyButton.remove();
          }
          destinationStickyCTA.innerHTML = sourceStickyCTA.innerHTML;
        }

        if (destinationVariantImage && sourceVariantImage) {
          const variantImgUrl = sourceVariantImage.dataset.variantImage;
          if (variantImgUrl) {
            destinationVariantImage.src = variantImgUrl;
          }
        }

        if (
          destinationMediaGallery &&
          sourceMediaGallery &&
          destinationMediaGallery.getElementsByTagName('script')[0] &&
          destinationMediaGallery.dataset.galleryScript
        ) {
          destinationMediaGallery.innerHTML = sourceMediaGallery.innerHTML;
          destinationMediaGallery.removeChild(destinationMediaGallery.getElementsByTagName('script')[0]);
          const script = document.createElement('script');
          script.setAttribute('type', 'text/javascript');
          script.src = destinationMediaGallery.dataset.galleryScript;
          destinationMediaGallery.appendChild(script);
        }

        if (destinationCtaVariantTitle && sourceCtaVariantTitle) {
          destinationCtaVariantTitle.innerHTML = sourceCtaVariantTitle.innerHTML;
        }

        if (destinationStickyPrice && sourceStickyPrice) {
          destinationStickyPrice.innerHTML = sourceStickyPrice.innerHTML;
        }
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price.querySelector('.price__container').classList.contains('sku_pricing')) {
          let selectedVariantLabelId = this.querySelector('input:checked').getAttribute('id');
          let getVariantLabelSKUPrice = this.querySelector(
            '[for=' + selectedVariantLabelId + '] .priceLabel'
          ).innerHTML.match(/\s*-\s*([\s\S]*)/);
          getVariantLabelSKUPrice = getVariantLabelSKUPrice[1].trim();
          price.querySelector('.price__container .price__regular .price-item').innerHTML = getVariantLabelSKUPrice;
          price.querySelector('.price__container .price__sale').innerHTML = getVariantLabelSKUPrice;
          const productPagesections = document.querySelectorAll('section');
          let checkStickyBarSection = this.dataset.section + '__sticky_cta_bar';
          checkStickyBarSection = checkStickyBarSection.replace('__main', '');
          productPagesections.forEach(section => {
            if (section.id.includes(checkStickyBarSection)) {
              const priceContainer = section.querySelector('.sub-nav__product-info.product-cta .price__container');
              if (priceContainer) {
                section.querySelector(
                  '.sub-nav__product-info.product-cta .price__regular .price-item'
                ).innerHTML = getVariantLabelSKUPrice;
                section.querySelector(
                  '.sub-nav__product-info.product-cta .price__sale'
                ).innerHTML = getVariantLabelSKUPrice;
              }
            }
          });
          function updatePriceWithRetries(retries) {
            if (retries <= 0) return;
            const priceElement = document.querySelector('[data-variant] .mobile-price');
            if (priceElement) {
              const priceContent = getVariantLabelSKUPrice;
              priceElement.innerHTML = priceContent;
              const pattern = /\$\d+(\.\d{2})? then \$\d+(\.\d{2})?/;
              if (pattern.test(priceContent)) {
                priceElement.classList.add('sku-pricing');
              } else {
                priceElement.classList.remove('sku-pricing');
              }

              priceElement.classList.add('varient-price');
            }
            setTimeout(() => updatePriceWithRetries(retries - 1), 10);
          }
          updatePriceWithRetries(2);
        } else {
          function updateDefaultPricing() {
            var priceDefault = document.querySelector('.mobile-price');
            var priceHtml = document.querySelector('.price-main');

            if (priceDefault && priceHtml) {
              priceDefault.innerHTML = '';
              priceDefault.innerHTML += priceHtml.innerHTML;
            }
          }
          setTimeout(() => updateDefaultPricing(), 10);
        }

        // subscription price change for mobile for fender
        const priceMobile = document.getElementById(`Mobile_price-${this.dataset.section}`);
        if (priceMobile.querySelector('.price__container').classList.contains('sku_pricing')) {
          let selectedVariantLabelId = this.querySelector('input:checked').getAttribute('id');
          let getVariantLabelSKUPrice = this.querySelector(
            '[for=' + selectedVariantLabelId + '] .priceLabel'
          ).innerHTML.match(/\s*-\s*([\s\S]*)/);
          getVariantLabelSKUPrice = getVariantLabelSKUPrice[1].trim();
          priceMobile.querySelector(
            '.price__container .price__regular .price-item'
          ).innerHTML = getVariantLabelSKUPrice;
          priceMobile.querySelector('.price__container .price__sale').innerHTML = getVariantLabelSKUPrice;
          const productPagesections = document.querySelectorAll('section');
          let checkStickyBarSection = this.dataset.section + '__sticky_cta_bar';
          checkStickyBarSection = checkStickyBarSection.replace('__main', '');
          productPagesections.forEach(section => {
            if (section.id.includes(checkStickyBarSection)) {
              const priceContainer = section.querySelector('.sub-nav__product-info.product-cta .price__container');
              if (priceContainer) {
                section.querySelector(
                  '.sub-nav__product-info.product-cta .price__regular .price-item'
                ).innerHTML = getVariantLabelSKUPrice;
                section.querySelector(
                  '.sub-nav__product-info.product-cta .price__sale'
                ).innerHTML = getVariantLabelSKUPrice;
              }
            }
          });
          function updatePriceWithRetries(retries) {
            if (retries <= 0) return;
            const priceElement = document.querySelector('[data-variant] .mobile-price');
            if (priceElement) {
              const priceContent = getVariantLabelSKUPrice;
              priceElement.innerHTML = priceContent;
              const pattern = /\$\d+(\.\d{2})? then \$\d+(\.\d{2})?/;
              if (pattern.test(priceContent)) {
                priceElement.classList.add('sku-pricing');
              } else {
                priceElement.classList.remove('sku-pricing');
              }

              priceElement.classList.add('varient-price');
            }
            setTimeout(() => updatePriceWithRetries(retries - 1), 10);
          }
          updatePriceWithRetries(2);
        } else {
          function updateDefaultPricing() {
            var priceDefault = document.querySelector('.mobile-price');
            var priceHtml = document.querySelector('.price-main');

            if (priceDefault && priceHtml) {
              priceDefault.innerHTML = '';
              priceDefault.innerHTML += priceHtml.innerHTML;
            }
          }
          setTimeout(() => updateDefaultPricing(), 10);
        }

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        this.updateBackPreOrders();
        this.updateVariantMetafield(this.currentVariant.id);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span.btn-text');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('hide-if-normal');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      addButton.classList.remove('hide-if-normal');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

// Mega Menu Mobile view
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.mega-menu__link--level-2');
  var html = document.querySelector('html');

  links.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();

      document.querySelectorAll('.mega-menu-sub.active').forEach(subMenu => {
        subMenu.classList.remove('active');
      });

      document.querySelectorAll('.mega-menu__link--level-2.active').forEach(activeLink => {
        activeLink.classList.remove('active');
      });

      this.classList.add('active');

      const subMenu = this.parentElement.nextElementSibling;

      if (subMenu && subMenu.classList.contains('mega-menu-sub')) {
        subMenu.classList.add('active');
        const closeButton = subMenu.querySelector('.mega-menu-sub__close-button');
        if (closeButton) {
          const buttonText = closeButton.querySelector('.button-text');
          if (buttonText) {
            buttonText.textContent = this.textContent.trim();
          }
        }
      }
    });
  });

  const closeButtons = document.querySelectorAll('.mega-menu-sub__close-button');

  closeButtons.forEach(button => {
    var html = document.querySelector('html');
    button.addEventListener('click', function() {
      const subMenu = this.parentElement;
      if (subMenu && subMenu.classList.contains('mega-menu-sub')) {
        subMenu.classList.remove('active');
      }

      document.querySelectorAll('.mega-menu__link--level-2.active').forEach(activeLink => {
        activeLink.classList.remove('active');
      });
    });
  });

  function boostSdSliderAfterChange() {
    document.querySelectorAll('.boost-sd__slider-container.slick-initialized').forEach(slider => {
      if (slider.slick) {
        slider.slick.$slider.off('afterChange');
      }
    });
  }

  setTimeout(() => {
    boostSdSliderAfterChange();
  }, 2000);

  const boostSdSliderObserver = new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.target.querySelector('.boost-sd__slider-container.slick-initialized')) {
        boostSdSliderAfterChange();
        observer.disconnect();
        break;
      }
    }
  });

  const config = { childList: true, subtree: true };
  boostSdSliderObserver.observe(document.body, config);

  function addAttributesProperties() {
    const mainProduct = document.querySelector('.product-main');
    if (mainProduct) {
      const appendElement = mainProduct.querySelector('#input-append');
      if (appendElement) {
        let srcCode = localStorage.getItem('srcCode');
        let srcCodeTwo = localStorage.getItem('src');
        if (srcCodeTwo && (!srcCode || srcCode === '')) {
          srcCode = srcCodeTwo;
        }
        let anonymousID = localStorage.getItem('ajs_anonymous_id');
        if (anonymousID && anonymousID.startsWith('"') && anonymousID.endsWith('"')) {
          anonymousID = anonymousID.slice(1, -1);
        }
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const userAgent = navigator.userAgent;
        const analyticsSessionId = localStorage.getItem('analytics_session_id') || '';
        const referrer = localStorage.getItem('shopify_referrer') || null;

        const ishiddenInputuserAgent = mainProduct.querySelector('[name="attributes[user_agent]"]');
        if (!ishiddenInputuserAgent) {
          const hiddenInputuserAgent = document.createElement('input');
          hiddenInputuserAgent.type = 'hidden';
          hiddenInputuserAgent.name = 'attributes[user_agent]';
          hiddenInputuserAgent.value = userAgent;
          appendElement.appendChild(hiddenInputuserAgent);
        }

        const ishiddenInputtimeZone = mainProduct.querySelector('[name="attributes[time_zone]"]');
        if (!ishiddenInputtimeZone) {
          const hiddenInputtimeZone = document.createElement('input');
          hiddenInputtimeZone.type = 'hidden';
          hiddenInputtimeZone.name = 'attributes[time_zone]';
          hiddenInputtimeZone.value = timeZone;
          appendElement.appendChild(hiddenInputtimeZone);
        }

        const ishiddenInputanalyticsSessionId = mainProduct.querySelector('[name="attributes[analytics_session_id]"]');
        if (!ishiddenInputanalyticsSessionId) {
          const hiddenInputanalyticsSessionId = document.createElement('input');
          hiddenInputanalyticsSessionId.type = 'hidden';
          hiddenInputanalyticsSessionId.name = 'attributes[analytics_session_id]';
          hiddenInputanalyticsSessionId.value = analyticsSessionId;
          appendElement.appendChild(hiddenInputanalyticsSessionId);
        }

        if (referrer) {
          const ishiddenInputreferrer = mainProduct.querySelector('[name="attributes[referrer]"]');
          if (!ishiddenInputreferrer) {
            const hiddenInputreferrer = document.createElement('input');
            hiddenInputreferrer.type = 'hidden';
            hiddenInputreferrer.name = 'attributes[referrer]';
            hiddenInputreferrer.value = referrer;
            appendElement.appendChild(hiddenInputreferrer);
          }
        }

        if (srcCode) {
          const ishiddenInputsrcCode = mainProduct.querySelector('[name="attributes[source_code]"]');
          if (!ishiddenInputsrcCode) {
            const hiddenInputsrcCode = document.createElement('input');
            hiddenInputsrcCode.type = 'hidden';
            hiddenInputsrcCode.name = 'attributes[source_code]';
            hiddenInputsrcCode.value = srcCode;
            appendElement.appendChild(hiddenInputsrcCode);
          }
        }

        if (anonymousID) {
          const ishiddenInputanonymousID = mainProduct.querySelector('[name="attributes[anonymous_id]"]');
          if (!ishiddenInputanonymousID) {
            const hiddenInputanonymousID = document.createElement('input');
            hiddenInputanonymousID.type = 'hidden';
            hiddenInputanonymousID.name = 'attributes[anonymous_id]';
            hiddenInputanonymousID.value = anonymousID;
            appendElement.appendChild(hiddenInputanonymousID);
          }
        }

        let datazz = document.getElementById('react-jwt-all');
        let customerid = datazz?.getAttribute('data-customerid') || '';
        let shopifycustomerid = datazz?.getAttribute('data-shopifycustomer') || '';
        let pageUrl = window.location.href;

        if (
          pageUrl.includes('products/') &&
          pageUrl.includes('play-subscription') &&
          customerid &&
          customerid !== '' &&
          shopifycustomerid &&
          shopifycustomerid !== ''
        ) {
          const ishiddenInputcustomerid = mainProduct.querySelector('input[name="properties[_fcID]"]');
          if (!ishiddenInputcustomerid) {
            const hiddenInputcustomerid = document.createElement('input');
            hiddenInputcustomerid.type = 'hidden';
            hiddenInputcustomerid.name = 'properties[_fcID]';
            hiddenInputcustomerid.value = customerid;
            appendElement.appendChild(hiddenInputcustomerid);
          }

          const ishiddenInputshopifycustomerid = mainProduct.querySelector(
            'input[name="properties[_shopifyCustomerID]"]'
          );
          if (!ishiddenInputshopifycustomerid) {
            const hiddenInputshopifycustomerid = document.createElement('input');
            hiddenInputshopifycustomerid.type = 'hidden';
            hiddenInputshopifycustomerid.name = 'properties[_shopifyCustomerID]';
            hiddenInputshopifycustomerid.value = shopifycustomerid;
            appendElement.appendChild(hiddenInputshopifycustomerid);
          }
          const ishiddenInputplaySub = mainProduct.querySelector('input[name="properties[_playSub]"]');
          if (!ishiddenInputplaySub) {
            const hiddenInputplaySub = document.createElement('input');
            hiddenInputplaySub.type = 'hidden';
            hiddenInputplaySub.name = 'properties[_playSub]';
            hiddenInputplaySub.value = 'true';
            appendElement.appendChild(hiddenInputplaySub);
          }
        }
        
        if (
          pageUrl.includes('products/') &&
          pageUrl.includes('studio-pro') &&
          customerid &&
          customerid !== '' &&
          shopifycustomerid &&
          shopifycustomerid !== ''
        ) {
          const ishiddenInputcustomerid = mainProduct.querySelector('input[name="properties[_fcID]"]');
          if (!ishiddenInputcustomerid) {
            const hiddenInputcustomerid = document.createElement('input');
            hiddenInputcustomerid.type = 'hidden';
            hiddenInputcustomerid.name = 'properties[_fcID]';
            hiddenInputcustomerid.value = customerid;
            appendElement.appendChild(hiddenInputcustomerid);
          }

          const ishiddenInputshopifycustomerid = mainProduct.querySelector(
            'input[name="properties[_shopifyCustomerID]"]'
          );
          if (!ishiddenInputshopifycustomerid) {
            const hiddenInputshopifycustomerid = document.createElement('input');
            hiddenInputshopifycustomerid.type = 'hidden';
            hiddenInputshopifycustomerid.name = 'properties[_shopifyCustomerID]';
            hiddenInputshopifycustomerid.value = shopifycustomerid;
            appendElement.appendChild(hiddenInputshopifycustomerid);
          }
          const ishiddenInputstudioPro = mainProduct.querySelector('input[name="properties[_studioPro]"]');
          if (!ishiddenInputstudioPro) {
            const hiddenInputstudioPro = document.createElement('input');
            hiddenInputstudioPro.type = 'hidden';
            hiddenInputstudioPro.name = 'properties[_studioPro]';
            hiddenInputstudioPro.value = 'true';
            appendElement.appendChild(hiddenInputstudioPro);
          }
        }

        if (pageUrl.includes('products/') && pageUrl.includes('play-subscription')) {
          const isHiddeninputHasPlaySub = mainProduct.querySelector('[name="attributes[has_play_sub]"]');
          if (!isHiddeninputHasPlaySub) {
            const isHiddeninputHasPlaySub = document.createElement('input');
            isHiddeninputHasPlaySub.type = 'hidden';
            isHiddeninputHasPlaySub.name = 'attributes[has_play_sub]';
            isHiddeninputHasPlaySub.value = 'true';
            appendElement.appendChild(isHiddeninputHasPlaySub);
          }
        }

        if (pageUrl.includes('products/') && pageUrl.includes('studio-pro')) {
          const isHiddeninputHasStudioPro = mainProduct.querySelector('[name="attributes[has_studio_pro]"]');
          if (!isHiddeninputHasStudioPro) {
            const isHiddeninputHasStudioPro = document.createElement('input');
            isHiddeninputHasStudioPro.type = 'hidden';
            isHiddeninputHasStudioPro.name = 'attributes[has_studio_pro]';
            isHiddeninputHasStudioPro.value = 'true';
            appendElement.appendChild(isHiddeninputHasStudioPro);
          }
        }
      }
    }
  };

  addAttributesProperties();

  function checkCartAttributes() {
    let dataz = document.getElementById('cart-sub-software-data');
    let subscriptioncart = dataz?.getAttribute('data-subscriptioncart') || '';
    let softwarecart = dataz?.getAttribute('data-softwarecart') || '';
    let cartAttributes = window.shopCart?.cartAttributes || {};
    let shouldUpdate = false;

    if(!softwarecart && cartAttributes['has_studio_pro'] === 'true'){
      cartAttributes['has_studio_pro'] = '';
      shouldUpdate = true;
    }

    if(!subscriptioncart && cartAttributes['has_play_sub'] === 'true'){
      cartAttributes['has_play_sub'] = '';
      shouldUpdate = true;
    }

    if(shouldUpdate) {
      const cartAttributesUpdate = {
        attributes: cartAttributes
      }
      if (window.shopSettings.environment !== 'prod') {
        console.log('checkCartAttributes updating cartAttributes:', cartAttributesUpdate);
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartAttributesUpdate)
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('checkCartAttributes Network response was not ok');
          }
          return response.json();
        });
    }
  };

  checkCartAttributes();
});

document.addEventListener('api-request-cart-attributes-updated', e => {
  if (
    e.detail.attributes.sub_exists &&
    (e.detail.attributes.sub_status == 'active' || e.detail.attributes.sub_status == 'pending')
  ) {
    let warnings = document.querySelectorAll('.already-exist-subscription-warning');
    if (warnings[0].dataset.playSubscription) {
      warnings.forEach(item => {
        item.classList.remove('hide');
      });

      document.querySelectorAll('button[name=checkout]').forEach(item => {
        item.setAttribute('disabled', true);
      });
    }
  }
  if (e.detail.attributes.software_exists == 'true' && e.detail.attributes.software_upgrade == 'false') {
    let warnings = document.querySelectorAll('.already-exist-software-warning');
    if (warnings[0].dataset.studioPro) {
      warnings.forEach(item => {
        item.classList.remove('hide');
      });

      document.querySelectorAll('button[name=checkout]').forEach(item => {
        item.setAttribute('disabled', true);
      });
    }
  }
});

document.addEventListener('api-request-cart-attributes-updated-new', e => {
  if (
    !window.shopAll.cartItemTitles.includes('Fender Play') &&
    e.detail.attributes.sub_exists &&
    (e.detail.attributes.sub_status == 'active' || e.detail.attributes.sub_status == 'pending')
  ) {
    if (
      (window.shopAll.cartItems == 1 && window.shopAll.cartItemTitles.includes('Fender Studio Pro')) ||
      (window.shopAll.cartItems == 2 &&
        window.shopAll.cartItemTitles.includes('Fender Studio Pro') &&
        window.shopAll.cartItemTitles.includes('Fender Play'))
    ) {
      return;
    }
    let warnings = document.querySelectorAll('.subscription-discount-success');
    warnings.forEach(item => {
      item.classList.remove('hide');
    });
  }
});
